module.exports = __webpack_public_path__ + "img/scan_sample.0964ed10.png";